module.exports = __webpack_public_path__ + "assets/25a32416abee198dd821b0b17a198a8f.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./~/font-awesome/fonts/fontawesome-webfont.eot?v=4.6.3
 ** module id = 1764
 ** module chunks = 1
 **/